import type { Theme } from '../../themes/themes';

export const createStepperTheme = (theme: Theme): Partial<Theme> => ({
  components: {
    MuiStepper: {
      styleOverrides: {
        root: {},
      },
      defaultProps: {},
    },
    MuiStep: {
      styleOverrides: {
        root: {},
        completed: {},
        horizontal: {
          paddingLeft: theme.spacing(0),
          paddingRight: theme.spacing(0),
        },
      },
    },
    MuiStepConnector: {
      styleOverrides: {
        lineHorizontal: {
          borderColor: theme.palette.grey[300],
          borderWidth: '2px',
          '.Mui-active > &': {
            borderColor: theme.palette.tileButton.border.selected,
            borderWidth: '2px',
          },
          '.Mui-completed > &': {
            borderColor: theme.palette.tileButton.border.selected,
            borderWidth: '2px',
          },
        },
      },
    },
    MuiStepLabel: {
      styleOverrides: {
        root: {
          borderColor: theme.palette.grey[300],
          borderWidth: '2px',
          '&:has(> .Mui-active)': {
            borderColor: theme.palette.tileButton.border.selected,
            borderWidth: '2px',
          },
          '.Mui-active + .MuiStep-root > &': {
            borderColor: theme.palette.tileButton.border.selected,
            borderWidth: '2px',
          },
          '.Mui-completed > &': {
            borderColor: theme.palette.tileButton.border.selected,
            borderWidth: '2px',
          },
          borderStyle: 'solid',
          borderRadius: theme.spacing(12),
          padding: theme.spacing(4),
        },
        label: {
          ...theme.typography.h6,
          paddingLeft: theme.spacing(2),
          paddingRight: theme.spacing(2),
          lineHeight: '18px', // TODO: what the fuck is this font switch?
          [theme.breakpoints.up('lg')]: {
            paddingLeft: theme.spacing(6),
            paddingRight: theme.spacing(6),
          },
        },
        iconContainer: {
          paddingRight: theme.spacing(0),
          color: theme.palette.tileButton.border.selected,

          svg: {
            fontSize: '12px',
            [theme.breakpoints.up('lg')]: {
              fontSize: '16px',
            },
          },
        },
      },
    },
  },
});
